/**
 * Generate the task platform client type.
 * Note: This utility will NOT validate if the combination of client type and client flavor is valid.
 * @param clientType The Uno client type
 * @param clientFlavor The Uno client flavor
 */ export function generateTaskPlatformClientType(clientType, clientFlavor) {
    return `${clientType}-${clientFlavor}`;
}
